import { FC, SVGProps } from 'react';

export const SearchIcon2: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.59375 9.4069C3.59375 6.02811 6.3328 3.28906 9.71159 3.28906C13.0904 3.28906 15.8294 6.02811 15.8294 9.4069C15.8294 12.7857 13.0904 15.5247 9.71159 15.5247C6.3328 15.5247 3.59375 12.7857 3.59375 9.4069ZM9.71159 2.35156C5.81503 2.35156 2.65625 5.51034 2.65625 9.4069C2.65625 13.3035 5.81503 16.4622 9.71159 16.4622C11.404 16.4622 12.9573 15.8663 14.173 14.8728L16.544 17.2376C16.7273 17.4205 17.0241 17.4201 17.2069 17.2368C17.3897 17.0535 17.3893 16.7567 17.206 16.5739L14.8586 14.2325C16.0421 12.9707 16.7669 11.2734 16.7669 9.4069C16.7669 5.51034 13.6081 2.35156 9.71159 2.35156Z"
			fill="currentColor"
		/>
	</svg>
);
